const c = new TextDecoder(), s = (e) => (e == null ? void 0 : e.type) === "public-key", d = async (e, n = "PWA", t = "PWA", i = {}) => {
  const o = new Uint8Array(64);
  window.crypto.getRandomValues(o);
  const a = {
    challenge: o,
    rp: {
      name: n
    },
    user: {
      id: Uint8Array.from(e, (r) => r.charCodeAt(0)),
      name: t,
      displayName: t
    },
    pubKeyCredParams: [
      { alg: -7, type: "public-key" },
      { alg: -257, type: "public-key" }
    ],
    authenticatorSelection: {
      authenticatorAttachment: "platform",
      userVerification: "discouraged",
      residentKey: "required"
    },
    timeout: 6e4,
    attestation: "direct",
    ...i
  };
  if ("credentials" in navigator) {
    const r = await navigator.credentials.create({
      publicKey: a
    });
    if (s(r))
      return r.id;
    throw new Error("Could not store secret");
  } else
    throw new Error("Could not find navigator");
}, u = async (e, n = {}) => {
  var a;
  const t = new Uint8Array(64);
  crypto.getRandomValues(t);
  const i = {
    allowCredentials: e === void 0 ? [] : [
      {
        id: Uint8Array.from(
          atob(l(e)),
          (r) => r.charCodeAt(0)
        ),
        type: "public-key"
      }
    ],
    challenge: t,
    userVerification: "discouraged",
    timeout: 6e4,
    ...n
  }, o = await navigator.credentials.get({
    publicKey: i
  });
  if (s(o)) {
    const r = (a = o.response) == null ? void 0 : a.userHandle;
    if (r !== null)
      return [c.decode(r), o.id];
    throw new Error("Response did not contain userHandle");
  } else
    throw new Error("Could not retrieve secret");
}, l = (e) => {
  let n = e.replace(/-/g, "+").replace(/_/g, "/");
  const t = e.length % 4;
  if (t) {
    if (t === 1)
      throw new Error(
        "InvalidLengthError: Input base64url string is the wrong length to determine padding"
      );
    n += new Array(5 - t).join("=");
  }
  return n;
};
export {
  d as create,
  u as get
};
